import { btnUtils, makeToast } from "./utils";

/* Seller Payout Features */
export const listingPayoutInit = async (cashConfig: PayoutCash, stripeAccountId: string) => {
  //determine the URL Stripe should return to from completing/cancelling the onboarding process
  const stripeReturnUrl = document.location.href;
  const cashPayoutOption = document.querySelector(".rec-payout-option-cash");
  const params = new URL(document.location.toString()).searchParams;
  const returnFromStripeOnboarding = params.get("return");

  // If we have a stripe account, check its onboarding status
  let stripeAccountInfo: null | Record<string, any> = null;
  if (stripeAccountId.trim().length > 0) {
    stripeAccountInfo = await sellerStripeManageLink(
      stripeAccountId,
      stripeReturnUrl,
      true,
    );

    if (stripeAccountInfo && !stripeAccountInfo.errors) {
      if (cashPayoutOption) {
        if (!returnFromStripeOnboarding) {
          cashPayoutOption.classList.add("rec-cash-loaded");
        }

        if (stripeAccountInfo.data.onboarded) {
          if (returnFromStripeOnboarding) {
            const listingId = cashPayoutOption.getAttribute("data-listing");
            if (listingId) {
              const payoutExecPath = recAppProxyConfig.paths.pathPayoutExec
                .replace("%lid%", listingId)
                .replace("%selection%", "cash")
                .replace("%aid%", stripeAccountId);
              const payoutResponse = await fetch(payoutExecPath, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
              });
              const payoutResults = await payoutResponse.json();

              if (!payoutResults.errors) {
                document.location.href =
                  recAppProxyConfig.paths.pathListings + `&t=tlpo`;
              }
            } else {
              console.error("Listing ID is null");
            }
          } else {
            cashPayoutOption.classList.add("rec-cash-active");
          }
        } else {
          cashPayoutOption.classList.add("rec-cash-loaded");
        }
      }
    } else {
      makeToast("toast-ajax-error");
    }
  } else {
    if (cashPayoutOption && !returnFromStripeOnboarding) {
      cashPayoutOption.classList.add("rec-cash-loaded");
    }
  }

  // Listen for clicking of seller payout choice
  document.querySelectorAll(".rec-payout-go").forEach((thisPayout) => {
    thisPayout.addEventListener("click", async (e) => {
      const target = e.currentTarget as HTMLButtonElement;
      btnUtils.loadingToggle(target);

      // Make the call to apply this payout preference to the listing
      const payoutListing = target.getAttribute("data-listing");
      const payoutType = target.getAttribute("data-payout");
      const payoutAccount =
        payoutType === "cash"
          ? stripeAccountId
          : target.getAttribute("data-account");

      if (payoutListing && payoutType && payoutAccount) {
        const payoutExecPath = recAppProxyConfig.paths.pathPayoutExec
          .replace("%lid%", payoutListing)
          .replace("%selection%", payoutType)
          .replace("%aid%", payoutAccount);

        try {
          const listingPayoutResponse = await fetch(payoutExecPath, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          });
          const listingPayoutResults = await listingPayoutResponse.json();

          if (!listingPayoutResults.errors) {
            document.location.href = recAppProxyConfig.paths.pathListings + `&t=tlpo`;
          } else {
            makeToast("toast-ajax-error");
            btnUtils.reset();
          }
        } catch (error) {
          console.error("Error processing payout:", error);
          makeToast("toast-ajax-error");
          btnUtils.reset();
        }
      } else {
        console.error("Required attributes are missing.");
        makeToast("toast-ajax-error");
        btnUtils.reset();
      }
    });
  });

  //listen for clicking of stripe setup/onboarding
  const stripeSetupBtn = document.querySelector(".rec-stripe-setup") as HTMLButtonElement;
  if (
    stripeSetupBtn &&
    cashConfig.vendors.map((vendor) => vendor.toLowerCase()).includes("stripe") && 
    cashConfig.enabled
  ) {
    stripeSetupBtn.addEventListener("click", async (e) => {
      btnUtils.loadingToggle(e.currentTarget as HTMLButtonElement);

      //we already have a stripe account, simply redirect to onboarding
      if (stripeAccountId.trim().length > 0) {
        if (stripeAccountInfo === null || stripeAccountInfo.errors) {
          makeToast("toast-ajax-error");
        } else {
          document.location = stripeAccountInfo.data.url;
        }
      } else {
        cashConfig.business_profile.url =
          cashConfig.business_profile?.url?.length > 0
            ? cashConfig.business_profile.url
            : recAppProxyConfig.settings.shop.url || "";
        cashConfig.country =
          stripeSetupBtn.dataset.country ??
          recAppProxyConfig.settings.payout.cash.country;
        stripeAccountId = await sellerStripeAccountCreate(cashConfig);
        if (stripeAccountId.length > 0) {
          const returnUrl = stripeReturnUrl + `?return=true`;
          const newStripeAccountDetails = await sellerStripeManageLink(
            stripeAccountId,
            returnUrl,
            false,
          );
          if (newStripeAccountDetails && !newStripeAccountDetails.errors) {
            document.location = newStripeAccountDetails.data.url;
          } else {
            makeToast("toast-ajax-error");
            btnUtils.reset();
          }
        } else {
          makeToast("toast-ajax-error");
          btnUtils.reset();
        }
      }
    });
  }
};

/* Functions to Support Stripe Communication */
async function sellerStripeManageLink(stripeAccountId: string, returnUrl: string, getAccountDetails: boolean) {
  if (stripeAccountId.length > 0) {
    let stripeDetailsPath = getAccountDetails
      ? recAppProxyConfig.paths.pathStripeDashboardGetDetails.replace(
        "%aid%",
        stripeAccountId,
      )
      : recAppProxyConfig.paths.pathStripeDashboardGet.replace(
        "%aid%",
        stripeAccountId,
      );
    const stripeLinkResponse = await fetch(
      `${stripeDetailsPath}&return_to=${encodeURIComponent(returnUrl)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );
    return await stripeLinkResponse.json();
  }
  return null;
}

async function sellerStripeAccountCreate(stripe: PayoutCash) {
  let formData = {
    stripeData: {
      business_profile: stripe.business_profile,
    },
  };

  try {
    const stripePath = recAppProxyConfig.paths.pathStripeAidPost.replace(
      "%country%",
      stripe.country,
    );
    let sripeAidResponse = await fetch(stripePath, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: { "Content-Type": "application/json" },
    });
    const sripeAidResponseResults = await sripeAidResponse.json();
    if (!sripeAidResponseResults.errors) {
      return sripeAidResponseResults.data.aid;
    }
  } catch (err) {
    console.error("sellerStripeAccountCreate: ", err);
  }

  return "";
}